/**
 * Incremental parser for the chat-proxy's SSE stream (`event:` line then
 * `data:` line, JSON payload). Feed it raw chunks from a ReadableStream
 * reader; it calls `onEvent` once per complete event.
 *
 * Network chunks split anywhere — between an `event:` line and its `data:`
 * line, mid-line, or inside a multi-byte character — so both the partial
 * line buffer and the pending event name persist across chunks. Resetting
 * the event name per chunk silently dropped events (a tool card left
 * spinning forever).
 */
export function createSSEParser(onEvent: (type: string, data: any) => void) {
  const decoder = new TextDecoder();
  let buffer = '';
  let eventType = '';

  return {
    push(chunk: Uint8Array) {
      buffer += decoder.decode(chunk, { stream: true });
      const lines = buffer.split('\n');
      buffer = lines.pop() || '';

      for (const raw of lines) {
        const line = raw.endsWith('\r') ? raw.slice(0, -1) : raw;
        if (line.startsWith('event: ')) {
          eventType = line.slice(7).trim();
        } else if (line.startsWith('data: ') && eventType) {
          const type = eventType;
          eventType = '';
          let data: any;
          try {
            data = JSON.parse(line.slice(6));
          } catch {
            continue; // skip malformed JSON
          }
          try {
            onEvent(type, data);
          } catch (err) {
            // One bad event must not kill the rest of the stream.
            console.error(`[chat] failed to handle SSE event "${type}"`, err);
          }
        }
      }
    },
  };
}
